import { stats } from "@/mocks/community";

export default function Stats() {
  return (
    <section className="relative overflow-hidden bg-primary-900 py-14 md:py-20">
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20stylized%20background%20of%20soft%20cherry%20blossom%20petals%20and%20bokeh%20light%20in%20deep%20rose%20and%20gold%20tones%2C%20dreamy%20artistic%20texture%2C%20subtle%20and%20elegant&width=1800&height=600&seq=stats-bg-2026&orientation=landscape"
          alt=""
          className="h-full w-full object-cover"
        />
      </div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-2 gap-6 text-center md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-2">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-background-50/15 text-accent-300">
                <i className={`${s.icon} text-2xl`}></i>
              </span>
              <p className="font-heading text-3xl font-black text-background-50 md:text-4xl">{s.value}</p>
              <p className="text-xs text-background-200 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}